import * as React from 'react';

import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton, Spinner, SpinnerSize, Text, Link } from '@fluentui/react';

export default class ErrorHandler extends React.Component {
  constructor() {
		super();
    this.state = {
      report: null
    }
  }

  _errorReplacer = (_key, value) => {
    if (value instanceof Error) {
      var error = {};
      Object.getOwnPropertyNames(value).forEach(function(errorKey) {
        error[errorKey] = value[errorKey];
      });
      return error;
    }
    return value;
  }

  _handleError = (e) => {
    console.error(e.error);
    this.setState({
      report: JSON.stringify({
        promise: false,
        error: e.error,
        message: e.message,
        source: e.source,
        pos: e.lineno + ':' + e.colno,
        agent: window.navigator.userAgent
      }, this._errorReplacer)
    });
  }

  _handleAsyncError = (e) => {
    console.error(e.reason);
    this.setState({
      report: JSON.stringify({
        promise: true,
        error: e.reason,
        agent: window.navigator.userAgent
      }, this._errorReplacer)
    });
  }

  _refresh = () => {
    window.location.search = '';
  }

  componentDidMount = () => {
    window.addEventListener('error', this._handleError);
    window.addEventListener('unhandledrejection', this._handleAsyncError);
	}
	
  componentWillUnmount = () => {
    window.removeEventListener('error', this._handleError);
    window.removeEventListener('unhandledrejection', this._handleAsyncError);
	}

	render() {
    return (
      <Dialog
        hidden={this.state.report === null}
        onDismiss={this._refresh}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: 'Errore',
          subText: 'È avvenuto un errore inaspettato!'
        }}
      >
        <DialogFooter>
          <DefaultButton onClick={() => {
            var blob = new Blob([this.state.report], {type: 'application/json'});
            var a = window.document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'mmlobug.liber.' + new Date().toISOString().replace(/:/g, '') + '.json'
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
          }} text="Salva report" />
          <PrimaryButton onClick={this._refresh} text="Riavvia" />
        </DialogFooter>
      </Dialog>
    );
	}
}
